import {
  ConfirmEmailRequest,
  ForgotPasswordRequest,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  RegisterAgentRequest,
  RegisterUserRequest,
  RegisterResponse,
  ResendEmailConfirmationRequest,
  ResetPasswordRequest,
} from "@/types/IdentityTypes";
import { createContext, useContext } from "react";

interface IdentityContextType {
  externalLogin: (loginProvider: string, returnUrl: string) => void;
  linkExternalProvider: (loginProvider: string, returnUrl: string) => void;
  logout: (logoutId?: string) => Promise<LogoutResponse>;
  login: (credentials: LoginRequest) => Promise<LoginResponse>;
  registerAgent: (request: RegisterAgentRequest) => Promise<RegisterResponse>;
  registerUser: (request: RegisterUserRequest) => Promise<RegisterResponse>;
  verifyEmailCode: (data: ConfirmEmailRequest) => Promise<void>;
  resendEmailConfirmation: (
    data: ResendEmailConfirmationRequest,
  ) => Promise<void>;
  requestPasswordReset: (email: ForgotPasswordRequest) => Promise<void>;
  resetPassword: (data: ResetPasswordRequest) => Promise<void>;
}

export const IdentityContext = createContext<IdentityContextType | null>(null);

export const useIdentity = () => {
  const context = useContext(IdentityContext);
  if (!context) {
    throw new Error("useIdentity must be used within an AuthProvider");
  }
  return context;
};
